import { Record } from 'immutable';
import { translate as t } from '../../lib/I18n';

import ValidationMixin from '../ValidationMixin';
import validation from '../../validation';

const defaults = {
    username: null,
    password: null
};

class Login extends Record(defaults) { // eslint-disable-line new-cap

    getSchema () {
        return {
            username: validation.email().messages({
                'string.base': t('alertmessage.login.badEmail'),
                'string.email': t('alertmessage.login.badEmail'),
            }),
            password: validation.passwordEntry()
        };
    }
}

Object.assign(Login.prototype, ValidationMixin);

export default Login;
